module.exports = __webpack_public_path__ + "img/arrow-left.044733bb.svg";